<template>
<div>
  <vs-table search :data="data" hoverFlat=false style="background-color: #F2F3F4 ; border-radius: 20px;">
    <!-- <template slot="header" >
      <div class="a" style=" margin-left: 1%; width: auto; margin-top: 1%; margin-bottom: 1%; border-radius: 5px; " >
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
          <vs-dropdown v-if="filter">
            <h6  class="a-icon" href.prevent>Filters : 
              {{ filtername }}
              <vs-icon class icon="expand_more" size="12px"></vs-icon>
            </h6>
            <vs-dropdown-menu>
              <vs-dropdown-item
                v-for="(item,index) in filterlist"
                :key="index"
                @click="filter(item)">
              {{ item.name }}
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </vs-col>
      </div>
    </template> -->
    
    <template slot="thead" >
      <vs-th style="padding: 0px">
      </vs-th>
      <vs-th v-for="item in header" :key="item" sort-key="name" style="padding: 0px;">
       
        {{item}} <span><vs-icon icon="unfold_more" size="16px"></vs-icon></span>
      </vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr v-for="item in data" :key="item.id">
        <vs-td>
          <vs-button v-if="viewfunc" class=" mr-2 " color="primary" type="flat" icon="add_circle" @click="viewfunc(item)">View</vs-button>
          <vs-button v-if="role == 'admin' && deleteurl" class="text-danger mr-2 " color="danger" type="flat" icon="delete" v-b-modal.modal-center @click="d=item" >Delete</vs-button>
          <!-- <vs-button v-if="role == 'admin'" class=" mr-2 "  size="small"  color="danger" type="filled" @click="del(item)">Delete</vs-button> -->
        </vs-td>
        <vs-td v-for="(item2,index2) in keys(item)" :key="index2" :data="item[item2]" >
          <div v-if="item2 == 'signal'">
            <vs-icon icon="rss_feed" color="primary"></vs-icon>
          </div>
          <div v-else-if="item2 == 'bat'">
            <vs-icon  icon="battery_full" color="primary"></vs-icon>
          </div>
          <div v-else-if="item2 == 'active'">
            <vs-icon icon="fiber_manual_record" v-if="item.active == 1" color="primary" ></vs-icon>
            <vs-icon icon="fiber_manual_record" v-else-if="item.active == 2" color="yellow" ></vs-icon>
            <vs-icon icon="fiber_manual_record" v-else color="grey"></vs-icon>
          </div>
          <div v-else >
          {{item[item2]}}
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  
  <b-modal id="modal-center" centered >
    <template #modal-title>
     <b class="text-danger"> <vs-icon icon="delete" size="small" color="red"></vs-icon>Delete Sensor</b> 
    </template>
    <p class="my-4 ">Do you want to delete sensor?</p>
    
     <template #modal-footer="{ cancel }">
     
    
      <!-- Button with custom close trigger value -->
       <vs-button class=" brdbtn" color="dark" style="width: 80px;" type="flat"  @click="cancel()" >Cancel</vs-button>   
      <!-- <b-button id="btncancel"  variant="light" @click="cancel()">
        Cancel
      </b-button> -->
      <vs-button v-if="role == 'admin'" color="danger" style="border-radius: 20px;" size="sm" @click="del()" type="filled">Delete</vs-button>
    </template>
    
  </b-modal>






  </div>
</template>

<script>
export default {
  name: 'Table',
  props: {
    viewfunc: Function,
    editfunc: Function,
    deleteurl: String,
    header: Array,
    filterlist: Array,
    filter: Function,
    filtername: String,
    data: Array,
    alertsensorid: Array,
  },
  computed: {
  },
  data: () => ({
    selected2: 0,
    d:'',
    role: '',
    selectedFilter: ''
  }),
  methods: {
    keys(item) {
      var check = 0
      var key = Object.keys(item)
      key.pop()
      key.forEach(element => {
        if(element == 'lora') check = 1
        else if(element == 'gatewayid') check = 2
      });
      if(check == 1)
      key.splice(Object.keys(item).indexOf('lora'),1)
      else if (check == 2)
      key.splice(Object.keys(item).indexOf('gatewayid'),1)
      return key
    },
    del(){
      // console.log(this.d)
      this.$http.post(this.$url+this.deleteurl, {
        id: this.d.serial_id,
        nw: this.d.network,
        token: this.$session.get('token')
      }).then(() => {
        this.$vs.notify({
          title: "Delete Sensor ",
          text: "Complete!",
          color: "danger",
          position: "top-center",
          icon: 'check'
        });
        setTimeout(() => {
          location.reload()
        }, 300);
      })
    }
  },
  mounted() {
    this.role = this.$session.get('role')
    // console.log('mounting table')
   
  }
}
</script>
<style scoped>
.vs-button{
  border-radius: 20px;
}
#btncancel{
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}
</style>
